<template>
    <div>
        <Page :page='content.page' :id='"dynamic_page_content"+type'>
            <template v-for='container in content.containers' :key='container.id'>
                <Container :container='container'>
                    <ContainerTabs v-if='container.tabs_enabled' :container='container' @tabSelectedListener='selectedContainerTab' />
                    <template v-for='block in container.blocks' :key='block.id'>
                        <Block :active_tabs='active_tabs' :block='block' :container_id='container.id'>
                            <template v-for='element in block.elements' :key='element.id' >
                                <Element :element='element'>
                                    <Image :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'image'"/>
                                    <Video :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'video'"/>
                                    <EmptySpace :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'empty_space'"/>
                                    <Carousel :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'carousel'"/>
                                    <Text :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'text'"/>
                                    <Button :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'button'"/>
                                    <ShopLocal :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'shop_local'"/>
                                    <MarketingEmails :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'marketing_emails'"/>
                                    <Products :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'products'"/>
                                    <Html :page_builder_mode='page_builder_mode' :content_type='type' :element='element' v-if="element.element_type == 'html'"/>
                                    <Card :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'card'"/>
                                    <CustomElement :page_builder_mode='page_builder_mode' :element='element' v-if="element.element_type == 'custom_element'"/>
                                    <template v-for='layer in element.layers' :key='layer.id'>
                                        <Layers :page_builder_mode='page_builder_mode' :layer='layer'/>
                                    </template>
                                </Element>
                            </template>
                        </Block>
                    </template>
                </Container>
            </template>
        </Page>
    </div>
</template>

<script>
import Page from '@/global/components/dynamic_pages/containers/Page.vue';
import Container from '@/global/components/dynamic_pages/containers/Container.vue';
import Block from '@/global/components/dynamic_pages/containers/Block.vue';
import Element from '@/global/components/dynamic_pages/containers/Element.vue';
import ContainerTabs from '@/global/components/dynamic_pages/containers/ContainerTabs.vue';

import Image from '@/global/components/dynamic_pages/elements/Image.vue';
import Video from '@/global/components/dynamic_pages/elements/Video.vue';
import EmptySpace from '@/global/components/dynamic_pages/elements/EmptySpace.vue';
import Carousel from '@/global/components/dynamic_pages/elements/Carousel.vue';
import Text from '@/global/components/dynamic_pages/elements/Text.vue';
import Button from '@/global/components/dynamic_pages/elements/Button.vue';
import ShopLocal from '@/global/components/dynamic_pages/elements/ShopLocal.vue';
import MarketingEmails from '@/global/components/dynamic_pages/elements/MarketingEmails.vue';
import Html from '@/global/components/dynamic_pages/elements/Html.vue';
import Card from '@/global/components/dynamic_pages/elements/Card.vue';
import CustomElement from '@/global/components/dynamic_pages/elements/CustomElement.vue';
import Products from '@/global/components/dynamic_pages/elements/Products.vue';

import Layers from '@/global/components/dynamic_pages/layers/Layers.vue';

import {importDynamicCss} from "@/global/modules/functions.js";

export default {
    components: {Image, Layers, Block, Element, Page, Container, ContainerTabs, Video, EmptySpace, Carousel, Text, ShopLocal, MarketingEmails, Html, Card, CustomElement, Button, Products},
    props:{
        content:{},
        page_builder_mode:{},
        type: {
            default: ''
        }
    },
    data(){
        return{
            active_tabs: []
        }
    },
    methods: {
        createDynamicCssForLivePreview(){
            let type = '';

            if(typeof this.type !== 'undefined'){
                type = this.type;
            }

            let stylesheet_id = 'dynamic_page_custom_css';
            
            if(type =='header'){
                stylesheet_id = 'dynamic_page_custom_css_header';
            }
            if(type =='footer'){
                stylesheet_id = 'dynamic_page_custom_css_footer';
            }

            importDynamicCss({
                css: this.content.page.css,
                scope_to: `#dynamic_page_content${type}`,
                stylesheet_id: stylesheet_id
            });
        },
        selectedContainerTab(container_id, tab_id){
            let tab = this.active_tabs.filter(x=>x.container_id == container_id)[0];
            if(tab == null){
                this.active_tabs.push({
                    container_id: container_id,
                    tab_id: tab_id
                });
            }
            else{
                tab.tab_id = tab_id;
            }
        }
    },
    beforeMount(){
        // if(typeof this.content.page !== 'undefined'){
        //     if(this.type != ''){
        //         importCss(`${this.$route.path}${this.type}`); //For built version
        //     }
        // }
    },
    watch:{
        'content': {
            handler(){
                this.createDynamicCssForLivePreview(); //For live preview
            },
            deep: true
        }
    }
}
</script>